import classes from "./login-content.module.scss";

import React, { useCallback } from "react";

import { CircleCheck, CircleX } from "lucide-react";

import { usePageLoginState } from "../../contexts";

export const LoginContentStatus = () => {
  const { status, setHasEmail, setStatus } = usePageLoginState();

  const handleGoBack = useCallback(() => {
    setStatus(-1);
    setHasEmail(false);
  }, [setHasEmail, setStatus]);

  switch (status) {
    case 200:
      return (
        <div className={classes["response"]}>
          <div className={classes["success"]}>
            <h1>
              <CircleCheck /> Thank you
            </h1>
            <h4>A link has been sent to your email.</h4>
          </div>
        </div>
      );
    default:
      return (
        <div className={classes["response"]}>
          <div className={classes["error"]}>
            <h1>
              <CircleX /> Error
            </h1>
            <h4>
              There was a problem with the email address you provided. Please contact your administrator for help or{" "}
              <button onClick={handleGoBack}>Try Again</button>.
            </h4>
          </div>
        </div>
      );
  }
};
